import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import NxtbnModal from '../../../components/Modal';
import { NXForm, InputField } from "../../../components/common";
import SelectStyled from '../../Select';
import useApi from '../../../api';
import { makeEnumFriendly } from '../../../enum';

interface ShippingChooserProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: any, isCustom: boolean) => void;
  customer?: any;
}

const shippingOptions = [
  { value: 'standard', label: 'Standard - ৳0.00' },
  { value: 'express', label: 'Express - ৳50.00' },
];

function ShippingChooser({ isOpen, onClose, onSubmit, customer }: ShippingChooserProps) {
  const [formData, setFormData] = useState<any>({});
  const [isCustom, setIsCustom] = useState(false);
  const [shippingList, setShippingList] = useState<any[]>([]);

  const api = useApi();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSelectChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      shipping_method: selectedOption
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData, isCustom);
  };

  const handleOptionChange = (option: string) => {
    setIsCustom(option === 'custom');

  };


  useEffect(() => {
    if (!isCustom && customer) {
      const params = {
        country: customer.default_shipping_address.country,
        city: customer.default_shipping_address.city,

      }
      api.getEligibleShippingMethods(params).then((response:any) => {
        setShippingList(response.results);
      }, (error) => {
        toast.error('Failed to fetch shipping methods');
      })
    }

  }, [isCustom, customer]);

  return (
    <NxtbnModal size='sm' isOpen={isOpen} onClose={onClose}>
      <NXForm
        onSubmit={handleSubmit}
        className="p-6"
        title="Shipping or Delivery Fee"
        nonFieldError={{}}
      >
        <div className="mb-6">
          <label className="block font-medium text-gray-700">Shipping Rates</label>
          <div className="mt-3">
            <div className="flex items-center">
              <InputField
                type="radio"
                id="shipping_method"
                name="shippingOption"
                value="rate"
                checked={!isCustom}
                onChange={() => handleOptionChange('rate')}
                className="mr-2"
              />
              <label htmlFor="shipping_method" className="text-sm">shipping rates</label>
            </div>
            <small>Select eligible shipping rates based on your Shipping settings</small>

            {!isCustom && (
              <div className="mt-3">
                <SelectStyled
                  options={shippingList}
                  onChange={handleSelectChange}
                  className="mt-2"
                  menuPortalTarget={document.body}
                  customStyles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),  // Ensure it's on top of other elements
                  }}
                />
              </div>
            )}

            <div className="flex items-center mt-4">
              <InputField
                type="radio"
                id="custom"
                name="shippingOption"
                value="custom"
                checked={isCustom}
                onChange={() => handleOptionChange('custom')}
                className="mr-2"
              />
              <label htmlFor="custom" className="text-sm">Custom</label>
            </div>

            {isCustom && (
              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Custom Shipping Name
                  </label>
                  <InputField
                    name="name"
                    placeholder="E.g. Free shipping"
                    value={formData.name || ''}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="price" className="block text-sm font-medium text-gray-700">
                    Custom Shipping Price
                  </label>
                  <InputField
                    name="price"
                    placeholder="$ 0.00"
                    value={formData.price || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Apply
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
}

export default ShippingChooser;
